<template>
  <!--试题收藏-->
  <div id="mycollection">
    <h2 class="title">
      <a href="" class="prev"></a>
      试题收藏
      <a href="" class="del">
        <img src="../../assets/icon/mycollection_icon_del.png" alt="">
      </a>
    </h2>
    <ul class="main">
      <li>小学综合素质 <span class="arrow"></span></li>
      <li>章节归类 <span class="arrow"></span></li>
    </ul>
    <div class="main0">
      <h4>暂无试题收藏</h4>
      <p>海量题库免费刷，快去做题吧～</p>
    </div>
    <ul class="main1">
      <li></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'MyCollection',
  data () {
    return {
      collectionData: {}
    }
  },
  methods: {
    getCollection () {
      let data = {
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_item_collection_question',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log(res)
          if (res.data.errcode === 200) {
            this.collectionData = res.data.data
          } else alert(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  mounted () {
    this.getCollection()
  }
}
</script>

<style scoped lang="stylus">
  #mycollection
    .title
      position: relative
      height: 1.08rem
      line-height: .8rem
      background-color: transparent
      padding: .14rem .16rem
      font-size: .32rem
      color: #050505
      font-weight: 600
      text-align: center
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      a.prev
        position: absolute
        top: .14rem
        left: .16rem
        display: block
        width: .8rem
        height: .8rem
        background-color: #fff
        -webkit-border-radius: 50%
        -moz-border-radius: 50%
        border-radius: 50%
        &::before
          content: ""
          position: absolute
          top: .3rem
          left: .32rem
          display: block
          width: .20rem
          height: .20rem
          border-left: .03rem solid #050505
          border-bottom: .03rem solid #050505
          -webkit-transform: rotate(45deg)
          -moz-transform: rotate(45deg)
          -ms-transform: rotate(45deg)
          -o-transform: rotate(45deg)
          transform: rotate(45deg)
      a.del
        position: absolute
        top: .2rem
        right: .32rem
        img
          width: .42rem
          height: .44rem
    ul.main
      display: flex
      justify-content: space-between
      align-items: center
      width: 6.54rem
      height: .8rem
      border-bottom: .02rem solid #CFD1D4
      margin: 0 auto
      li
        position: relative
        width: 50%
        line-height: .8rem
        font-size: .32rem
        color: #333
        text-align: center
        &::before
          content: ""
          position: absolute
          top: .25rem
          left: -.01rem
          width: .02rem
          height: .26rem
          background-color: #979797
        &:first-child::before
          display: none
        span.arrow
          display: inline-block
          width: 0
          height: 0
          border-top: .2rem solid #464646
          border-left: .13rem solid transparent
          border-right: .13rem solid transparent
          margin-left: .2rem
    .main0
      h4
        margin: 4.62rem 0 .2rem
        font-size: .32rem
        color: #050505
        text-align: center
      p
        font-size: .24rem
        color: #9DA4B3
        text-align: center
</style>



// WEBPACK FOOTER //
// src/components/personal/MyCollection.vue